import React from 'react';
import {
  MapIcon,
  StopCircleIcon,
  ArrowsRightLeftIcon,
  ShieldCheckIcon,
  CogIcon,
  ArchiveBoxIcon,
  DocumentDuplicateIcon,
  PencilSquareIcon,
  RocketLaunchIcon,
  SparklesIcon,
  ChartBarIcon,
  BookOpenIcon,
} from '@heroicons/react/24/outline';
import ChapterWhatIsPlaybook from './chapters/ChapterWhatIsPlaybook';
import ChapterStatuses from './chapters/ChapterStatuses';
import ChapterTransitions from './chapters/ChapterTransitions';
import ChapterGuardsValidators from './chapters/ChapterGuardsValidators';
import ChapterActions from './chapters/ChapterActions';
import ChapterLibrary from './chapters/ChapterLibrary';
import ChapterCloning from './chapters/ChapterCloning';
import ChapterVisualEditor from './chapters/ChapterVisualEditor';
import ChapterPublishing from './chapters/ChapterPublishing';
import ChapterAIAssistant from './chapters/ChapterAIAssistant';
import ChapterAnalytics from './chapters/ChapterAnalytics';
import ChapterGlossary from './chapters/ChapterGlossary';

export interface HandbookChapter {
  id: string;
  title: string;
  subtitle: string;
  icon: React.FC<{ className?: string }>;
  keywords: string[];
  render: () => React.ReactElement;
}

export const HANDBOOK_CHAPTERS: HandbookChapter[] = [
  {
    id: 'what-is-playbook',
    title: 'What is a Playbook?',
    subtitle: 'The Highway Map',
    icon: MapIcon,
    keywords: ['workflow', 'template', 'state machine', 'overview', 'introduction', 'getting started'],
    render: () => <ChapterWhatIsPlaybook />,
  },
  {
    id: 'statuses',
    title: 'Understanding Statuses',
    subtitle: 'Traffic Stops',
    icon: StopCircleIcon,
    keywords: ['status', 'state', 'phase', 'category', 'todo', 'in progress', 'done', 'blocked', 'initial', 'terminal', 'sla'],
    render: () => <ChapterStatuses />,
  },
  {
    id: 'transitions',
    title: 'Transitions',
    subtitle: 'On-Ramps & Off-Ramps',
    icon: ArrowsRightLeftIcon,
    keywords: ['transition', 'move', 'trigger', 'manual', 'event', 'deadline', 'automatic', 'connect'],
    render: () => <ChapterTransitions />,
  },
  {
    id: 'guards-validators',
    title: 'Guards & Validators',
    subtitle: 'Tollbooths & Checkpoints',
    icon: ShieldCheckIcon,
    keywords: ['guard', 'validator', 'condition', 'pre-condition', 'role', 'permission', 'approval', 'block', 'check'],
    render: () => <ChapterGuardsValidators />,
  },
  {
    id: 'actions',
    title: 'Actions',
    subtitle: 'The Autopilot',
    icon: CogIcon,
    keywords: ['action', 'automation', 'notification', 'webhook', 'deadline', 'calculate', 'email', 'task'],
    render: () => <ChapterActions />,
  },
  {
    id: 'library',
    title: 'The Playbook Library',
    subtitle: "Your Firm's Filing Cabinet",
    icon: ArchiveBoxIcon,
    keywords: ['library', 'browse', 'filter', 'system', 'firm', 'manage', 'list', 'card'],
    render: () => <ChapterLibrary />,
  },
  {
    id: 'cloning',
    title: 'Cloning & Customizing',
    subtitle: 'Making It Yours',
    icon: DocumentDuplicateIcon,
    keywords: ['clone', 'copy', 'customize', 'modify', 'upstream', 'changes', 'variant', 'diff'],
    render: () => <ChapterCloning />,
  },
  {
    id: 'visual-editor',
    title: 'The Visual Editor',
    subtitle: 'The Blueprint Table',
    icon: PencilSquareIcon,
    keywords: ['editor', 'canvas', 'diagram', 'drag', 'drop', 'node', 'edge', 'toolbar', 'property', 'layout'],
    render: () => <ChapterVisualEditor />,
  },
  {
    id: 'publishing',
    title: 'Publishing & Versioning',
    subtitle: 'Going Live',
    icon: RocketLaunchIcon,
    keywords: ['publish', 'version', 'draft', 'active', 'lifecycle', 'superseded', 'archive', 'validation'],
    render: () => <ChapterPublishing />,
  },
  {
    id: 'ai-assistant',
    title: 'AI Assistant',
    subtitle: 'Your Digital Paralegal',
    icon: SparklesIcon,
    keywords: ['ai', 'generate', 'artificial intelligence', 'gap', 'detection', 'ghost', 'suggestion', 'confidence'],
    render: () => <ChapterAIAssistant />,
  },
  {
    id: 'analytics',
    title: 'Analytics & Diagnostics',
    subtitle: 'The Dashboard',
    icon: ChartBarIcon,
    keywords: ['analytics', 'metrics', 'dashboard', 'bottleneck', 'sla', 'compliance', 'guard failure', 'version compare'],
    render: () => <ChapterAnalytics />,
  },
  {
    id: 'glossary',
    title: 'Glossary',
    subtitle: 'Quick Reference',
    icon: BookOpenIcon,
    keywords: ['glossary', 'definition', 'term', 'reference', 'dictionary'],
    render: () => <ChapterGlossary />,
  },
];
